<script setup lang="ts">
const { brandingOptions, isBrandingLoaded } = useBrandingOptions()

const faviconLinks = computed(() => {
  // Do not expose any favicon before branding has loaded.
  // Safari may keep using the first favicon it sees, including /favicon.ico.
  if (!isBrandingLoaded.value)
    return []

  const faviconUrl = brandingOptions.value?.favicon_url
  if (faviconUrl) {
    return [
      {
        key: 'favicon',
        rel: 'icon',
        href: faviconUrl,
      },
    ]
  }

  return [
    {
      key: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      sizes: '16x16',
      href: '/docue-favicon.ico',
    },
    {
      key: 'favicon-svg',
      rel: 'icon',
      type: 'image/svg+xml',
      href: '/docue-favicon.svg',
    },
    {
      key: 'apple-touch-icon',
      rel: 'apple-touch-icon',
      href: '/docue-favicon-apple.png',
    },
    {
      key: 'manifest',
      rel: 'manifest',
      href: '/manifest.json',
    },
  ]
})

useHead(() => ({
  titleTemplate: titleChunk => [titleChunk, 'Embeddable Builder'].filter(Boolean).join(' - '),
  htmlAttrs: {
    class: 'antialiased',
  },
  link: faviconLinks.value,
}))
</script>

<template>
  <NuxtLoadingIndicator />
  <UiTooltipProvider>
    <NuxtPage />
  </UiTooltipProvider>
  <UiToaster
    position="top-right"
    class="right-4 top-[4.5rem]"
  />
</template>
